var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWindow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "window_svg__a",
  width: 16,
  height: 16,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h16v16H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#window_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8.667 8.667H14v4c0 .366-.13.68-.392.941a1.284 1.284 0 0 1-.941.392h-4V8.667Zm0-1.334V2h4c.366 0 .68.13.941.392.261.26.392.575.392.941v4H8.667Zm-1.334 0H2v-4c0-.366.13-.68.392-.941.26-.261.575-.392.941-.392h4v5.333Zm0 1.334V14h-4c-.366 0-.68-.13-.941-.392A1.284 1.284 0 0 1 2 12.667v-4h5.333Z"
}))));
export default SvgWindow;